import { lazy } from "react";
import { HomeRoutes, ProtectedRoutes } from "./ProtectedRoute";

export const routeMap = [
  {
    layout: ProtectedRoutes,
    path: "/login",
    element: lazy(() => import("./Components/Login")),
  },
  {
    layout: HomeRoutes,
    path: "/Dashboard",
    element: lazy(() => import("./Components/Dashboard")),
  },
  {
    layout: HomeRoutes,
    path: "/ImageDetail",
    element: lazy(() => import("./Components/ImagePage")),
  },
  {
    layout: HomeRoutes,
    path: "/My_job",
    element: lazy(() => import("./Components/Myjob")),
  },
  {
    layout: HomeRoutes,
    path: "/My_Profile",
    element: lazy(() => import("./Components/MyProfile")),
  },
  {
    layout: HomeRoutes,
    path: "/Apointment_Details",
    element: lazy(() => import("./Components/ApointmentDetail")),
  },
  {
    layout: HomeRoutes,
    path: "/Add_Patient",
    element: lazy(() => import("./Components/AddPatient")),
  },
  {
    layout: HomeRoutes,
    path: "/New_Job",
    element: lazy(() => import("./Components/NewJob")),
  },
  {
    layout: HomeRoutes,
    path: "/Max_Phelebo_UAT",
    element: lazy(() => import("./Components/MaxPhleboUAT")),
  },
  {
    layout: HomeRoutes,
    path: "/Sign",
    element: lazy(() => import("./Components/SignaturePage")),
  },
  {
    layout: HomeRoutes,
    path: "/Reasons",
    element: lazy(() => import("./Components/Reasons")),
  },
];
